import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import Button from "../../../modules/commons/Button";
import SimpleTimePicker from "../../../modules/SimpleTimePicker";
import moment from "moment";
import Api from "../../../Services/Api";
import { shortUuid } from "../masterSopir/utils";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleInput from "../../../modules/SimpleInput";

class ComponentTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || [],
      editingIndex: null,
      pagination: {
        totalData: props.resdata?.totalData || 0,
        page: 1,
        limit: 5,
      },
      loading: false,
      userAccess: {},
    };
  }

  tableColumns = [
    {
      name: "no",
      label: "No",
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, tableMeta) => {
          const { page, limit } = this.state.pagination;
          const rowIndex = tableMeta.rowIndex;
        
          return (page - 1) * limit + rowIndex + 1;
        },
      },
    },
    { name: "bookingId", label: "ID Slot" },
    {
      name: "bookingTime",
      label: "Jam Booking",
      options: {
        customBodyRender: (val, tableMeta) => {
          const index = tableMeta.rowIndex;
          const row = this.state.data[index];
          const isEditing = row?.isNew || this.state.editingIndex === index;
          return isEditing ? (
            // <SimpleTimePicker
            //   defaultValue={
            //     row.bookingTime ? moment(row.bookingTime, "HH:mm") : null
            //   }
            //   value={(val) => this.handleTimeChange(index, val)}
            // />
            <SimpleInput
              align="left"
              box="timePicker"
              name="bookingTime"
              value={row.bookingTime || ""}
              // onChange={(value) => this.handleTimeChange(index, value)}
              onChange={(value) => {
                let formatted = value;
                if (typeof value === "string" && value.includes("T")) {
                  formatted = moment(value).format("HH:mm");
                }
                this.handleTimeChange(index, formatted, false);
              }}
            />
          ) : (
            <span>{row.bookingTime || "--:--"}</span>
          );
        },
      },
    },
    {
      name: "action",
      label: "Aksi",
      options: {
        customBodyRender: (_, tableMeta) => {
          const index = tableMeta.rowIndex;
          const row = this.state.data[index];
          const isEditing = this.state.editingIndex === index;

          return (
            <FlexView vAlignContent="center" style={{ gap: 10 }}>
              {row.isNew || isEditing ? (
                <>
                  <Button
                    className="btnAct"
                    onClick={() => this.handleSaveRow(index)}
                  >
                    <i
                      className="fa fa-save"
                      style={{ fontSize: 20, color: "red" }}
                    />
                  </Button>
                  <Button
                    className="btnAct"
                    onClick={() => this.handleDeleteRow(index)}
                  >
                    <i
                      className="fa fa-trash"
                      style={{ fontSize: 20, color: "red" }}
                    />
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    className="btnAct"
                    disabled={!this.props.userAccess?.updateAccess}
                    onClick={() => this.handleEditRow(index)}
                  >
                    <i
                      className="fa fa-pencil-alt"
                      style={{
                        fontSize: 20,
                        color: this.props.userAccess?.updateAccess
                          ? "red"
                          : "black",
                      }}
                    />
                  </Button>
                  <Button
                    className="btnAct"
                    disabled={!this.props.userAccess?.createAccess}
                    onClick={() => this.handleCopyRow(index)}
                  >
                    <i
                      className="fa fa-copy"
                      style={{
                        fontSize: 20,
                        color: this.props.userAccess?.createAccess
                          ? "red"
                          : "black",
                      }}
                    />
                  </Button>
                  <Button
                    className="btnAct"
                    disabled={!this.props.userAccess?.deleteAccess}
                    onClick={() => this.handleDeleteRow(index)}
                  >
                    <i
                      className="fa fa-trash"
                      style={{
                        fontSize: 20,
                        color: this.props.userAccess?.deleteAccess
                          ? "red"
                          : "black",
                      }}
                    />
                  </Button>
                </>
              )}
            </FlexView>
          );
        },
      },
    },
  ];

  // componentDidUpdate(prevProps) {
  //   if (
  //     prevProps.data !== this.props.data ||
  //     prevProps.selectedCabang !== this.props.selectedCabang ||
  //     prevProps.hari !== this.props.hari
  //   ) {
  //     const totalData = this.props.resdata?.totalData || 0;
  //     const { page, limit } = this.state.pagination;
  //     const totalPages = Math.ceil(totalData / limit);
  //     const correctedPage = Math.min(page, totalPages) || 1;

  //     this.setState((prev) => ({
  //       data: this.props.data || [],
  //       pagination: {
  //         ...prev.pagination,
  //         totalData,
  //         page: correctedPage,
  //       },
  //     }));
  //   }
  // }

  componentDidUpdate(prevProps) {
    if (
      prevProps.limit !== this.props.limit ||
      prevProps.page !== this.props.page
    ) {
      this.setState((prev) => ({
        pagination: {
          ...prev.pagination,
          limit: this.props.limit,
          page: this.props.page,
        },
      }));
    }
    if(prevProps.selectedCabang !== this.props.selectedCabang){
      this.setState((prev) => ({
        data: this.props.data || [],
        pagination: {
          ...prev.pagination,
          totalData: this.props.resdata?.totalData,
          page: 1,
        },
      }));
    }
    if (
      prevProps.data !== this.props.data ||
      // prevProps.selectedCabang !== this.props.selectedCabang ||
      prevProps.hari !== this.props.hari
    ) {
      if (this.state.editingIndex !== null) return;

      const totalData = this.props.resdata?.totalData || 0;
      const { page, limit } = this.state.pagination;
      const totalPages = Math.ceil(totalData / limit);
      const correctedPage = Math.min(page, totalPages) || 1;

      this.setState((prev) => ({
        data: this.props.data || [],
        pagination: {
          ...prev.pagination,
          totalData,
          page: correctedPage,
        },
      }));
    }
  }

  updateData = (newData) => {
    if (typeof this.props.onDataChange === "function") {
      this.props.onDataChange(this.props.hari, newData);
    }
    this.setState((prev) => ({
      pagination: { ...prev.pagination, totalData: newData.length },
    }));
  };

  handleAddRow = () => {
    const updated = [
      ...this.state.data,
      {
        id: null,
        bookingId: shortUuid(),
        bookingTime: "",
        isNew: true,
      },
    ];
    this.setState({
      data: updated,
      pagination: { ...this.state.pagination, totalData: updated.length },
    });
    this.updateData(updated);
  };

  handleEditRow = (index) => {
    this.setState({ editingIndex: index });
  };

  handleSaveRow = async (index) => {
    const { selectedCabang, hari } = this.props;
    const { data } = this.state;
    const row = data[index];

    if (!row.bookingTime) {
      alert("Silakan pilih jam booking terlebih dahulu!");
      return;
    }

    const payload = {
      id: row.id || null,
      bookingId: row.bookingId || shortUuid(),
      kodeCabang: selectedCabang?.value || "",
      bookingTime: row.bookingTime,
      day: hari.toUpperCase(),
    };

    try {
      this.handleTriggerLoading(true);
      const api = Api.create("NAGAMAS_MASTER_DATA");
      const res = await api.saveMasterBooking(payload);

      if (res.ok) {
        const updated = data.map((item, i) =>
          i === index ? { ...item, isNew: false } : item
        );
        this.setState({ editingIndex: null, data: updated });
        this.updateData(updated);
        if (typeof this.props.onRefresh === "function") {
          await this.props.onRefresh();
        }
        this.handleRefreshPagination();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  handleCopyRow = async (index) => {
    const { selectedCabang, hari } = this.props;
    const { data } = this.state;
    const row = data[index];

    const payload = {
      id: null,
      bookingId: shortUuid(),
      kodeCabang: selectedCabang?.value || "",
      bookingTime: row.bookingTime,
      day: hari.toUpperCase(),
    };

    try {
      this.handleTriggerLoading(true);
      const api = Api.create("NAGAMAS_MASTER_DATA");
      const res = await api.saveMasterBooking(payload);

      if (res.ok) {
        if (typeof this.props.onRefresh === "function") {
          await this.props.onRefresh();
        }
        this.handleRefreshPagination();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  handleDeleteRow = async (index) => {
    const { data } = this.state;
    const bookingId = data[index]?.bookingId;

    try {
      this.handleTriggerLoading(true);
      const api = Api.create("NAGAMAS_MASTER_DATA");
      const res = await api.deleteMasterBooking(bookingId);

      if (res.ok) {
        const updated = data.filter((_, i) => i !== index);
        this.setState({
          data: updated,
          pagination: { ...this.state.pagination, totalData: updated.length },
        });
        this.updateData(updated);
        if (typeof this.props.onRefresh === "function") {
          await this.props.onRefresh();
        }
        this.handleRefreshPagination();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  // handleTimeChange = (index, value) => {
  //   const updated = [...this.state.data];
  //   updated[index].bookingTime = value || "";
  //   // updated[index].bookingTime = value
  //   //   ? value.format("HH:mm")
  //   //   : moment().format("HH:mm");
  //   this.setState({ data: updated });
  //   this.updateData(updated);
  // };

  handleTimeChange = (index, value, silent) => {
    const updated = [...this.state.data];
    updated[index].bookingTime = value;

    this.setState({ data: updated });
    if (!silent) {
      this.updateData(updated);
    }
  };

  handleChangePage = (tableState) => {
    const newPage = tableState.page + 1;
    this.setState(
      (prev) => ({
        pagination: {
          ...prev.pagination,
          page: newPage,
        },
      }),
      () => {
        if (typeof this.props.onFetchData === "function") {
          this.props.onFetchData(
            this.state.pagination.page,
            this.state.pagination.limit
          );
        }
      }
    );
  };

  handleRowsPerPage = (tableState) => {
    const newLimit = tableState.rowsPerPage;

    this.setState(
      (prev) => ({
        pagination: {
          ...prev.pagination,
          limit: newLimit,
          totalData: 0,
          page: 1,
        },
      }),
      () => {
        if (typeof this.props.onFetchData === "function") {
          this.props.onFetchData(1, this.state.pagination.limit);
        }
      }
    );
  };

  handleRefreshPagination = () => {
    this.setState((prevState, props) => ({
      pagination: {
        ...prevState.pagination,
        page: prevState.pagination.page,
        limit: prevState.pagination.limit,
        totalData: props.resdata?.totalData || prevState.data.length,
      },
    }));
  };

  handleTriggerLoading = (status = null) => {
    this.setState((prev) => ({
      ...prev,
      loading: status !== null ? status : !prev.loading,
    }));
  };

  render() {
    const { pagination, data, loading } = this.state;
    return (
      <>
        <FlexView style={{ margin: "20px 0" }}>
          <SimpleButton
            secondary={!this.props.userAccess?.createAccess ? true : false}
            disabled={!this.props.userAccess?.createAccess}
            icon={<i className="fa fa-plus margin-right-10px" />}
            onClick={this.handleAddRow}
          >
            Tambah
          </SimpleButton>
        </FlexView>

        <SimpleDataTable
          toCount={pagination.totalData}
          data={data}
          columns={this.tableColumns}
          rowsPerPage={this.props.limit}
          page={this.props.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
        />

        {loading && <SimpleLoadingOverlay active={loading} />}
      </>
    );
  }
}

export default ComponentTabs;
